import { TextInput } from '@/components'
import { createStyles } from '@codeleap/styles'
import { PropsOf } from '@codeleap/types'

export type DateInputProps = Partial<PropsOf<typeof TextInput>>

export const DateInput = ({ label = 'Date', debugName, ...props }: DateInputProps) => {

  return (
    <TextInput
      leftIcon={{ name: 'calendar' }}
      label={label}
      debugName={debugName}
      {...props}
      style={['rightIcon:pointer', { input: styles.dateInput }, props?.style]}
      type='date'
    />
  )
}

const styles = createStyles(() => ({
  dateInput: {
    '&::-webkit-calendar-picker-indicator': {
      opacity: 0,
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
    },
    '&::-webkit-inner-spin-button': {
      display: 'none',
    },
    position: 'relative',
  },
}))
